import { render, staticRenderFns } from "./edit-personal-device-dialog.vue?vue&type=template&id=f966132e&scoped=true&"
import script from "./edit-personal-device-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-personal-device-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f966132e",
  null
  
)

export default component.exports